import { render, staticRenderFns } from "./PageError.vue?vue&type=template&id=6703770a&"
import script from "./PageError.vue?vue&type=script&lang=ts&"
export * from "./PageError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports